<template>
  <div class="">
    <div
      class="c-filter__show-filters-banner"
      v-if="!showFilters && !isDesktop"
    >
      <div class="c-mobile-nav__search c-contact-filter__search">
        <label for="search-input" class="t-visually-hidden">S&#246;k</label>
        <input
          @keyup.enter="searchContacts"
          type="text"
          name="q"
          id="search-input mobile-search-bar input"
          :placeholder="this.translate.searchonnameorroleorcity"
          v-model="searchValue"
        />
        <button v-if="searchValue" class="clear-button" @click="clearSearch">
          <span
            aria-hidden="true"
            class="c-icon c-icon--xxs c-main-nav__close-icon"
          >
            <svg>
              <use xlink:href="#icon-close"></use>
            </svg>
          </span>
        </button>
        <div class="container-search-button">
          <button
            type="submit"
            class="c-main-nav__search-button c-contact-filter__button"
            @click="searchContacts"
          >
            <span class="t-visually-hidden">S&#246;k</span>
            <span
              aria-hidden="true"
              class="c-icon c-icon--xs c-main-nav__search-icon"
            >
              <svg>
                <use xlink:href="#icon-search"></use>
              </svg>
            </span>
          </button>
        </div>
      </div>
      <div class="filter-results-container">
        <button @click="showMobileFilters" class="filter-button">
          <div class="container-filter-button">
            <span class="filter-text">{{ this.translate.filter }}</span>
            <span aria-hidden="true" class="c-icon c-icon--xs slider-icon">
              <svg>
                <use xlink:href="#icon-sliders"></use>
              </svg>
            </span>
          </div>
        </button>
      </div>
    </div>
    <div class="c-filter c-contact-filter" v-if="showFilters || isDesktop">
      <div class="c-filter__wrapper c-contact-filter__wrapper">
        <div
          class="c-filter__content-wrapper c-contact-filter__content-wrapper o-width-limiter"
        >
          <div
            class="c-filter__dropdown-wrapper c-contact-filter__dropdown-wrapper"
          >
            <v-filter-dropdown
              v-for="filter in filters"
              :key="filter.id"
              @toggle-dropdown="toggleDropdown(filter.id)"
              :id="filter.id"
              :button-text="getSelectedLabel(filter)"
              :dropdown-open="activeFilter === filter.id"
              :translate="translate"
              :label="filter.label"
            >
              <ul
                class="c-filter-dropdown__list"
                v-if="isDesktop && activeFilter === filter.id"
                v-click-outside="handleClickOutside"
              >
                <div class="c-filter__city-wrapper">
                  <!-- Top-level options -->
                  <li
                    v-for="option in filter.options"
                    :key="option.value"
                    class="c-filter__city"
                    @click="handleSelection(filter, option)"
                  >
                    <span
                      :class="{
                        'has-sub-options':
                          option.options && option.options.length > 0,
                      }"
                      >{{ option.text }}</span
                    >

                    <!-- Nested (sub) options -->
                    <p
                      v-for="sub in option.options || []"
                      :key="sub.value"
                      class="c-filter__city ml-4"
                      @click.stop="handleSelection(filter, sub)"
                    >
                      {{ sub.text }}
                    </p>
                  </li>
                </div>
              </ul>
              <ul
                class="c-filter-dropdown__list"
                v-if="!isDesktop && activeFilter === filter.id"
              >
                <div class="c-filter__city-wrapper">
                  <!-- Top-level options -->
                  <li
                    v-for="option in filter.options"
                    :key="option.value"
                    class="c-filter__city"
                    @click="handleSelection(filter, option)"
                  >
                    <span
                      :class="{
                        'has-sub-options':
                          option.options && option.options.length > 0,
                      }"
                      >{{ option.text }}</span
                    >

                    <!-- Nested (sub) options -->
                    <p
                      v-for="sub in option.options || []"
                      :key="sub.value"
                      class="c-filter__city ml-4"
                      @click.stop="handleSelection(filter, sub)"
                    >
                      {{ sub.text }}
                    </p>
                  </li>
                </div>
              </ul>
            </v-filter-dropdown>
            <div class="c-main-nav__search c-contact-filter__search">
              <label for="search-input" class="t-visually-hidden"
                >S&#246;k</label
              >
              <input
                type="text"
                name="q"
                id="search-input"
                :placeholder="this.translate.searchonnameorroleorcity"
                @keyup.enter="searchContacts"
                v-model="searchValue"
              />
              <button
                v-if="searchValue"
                class="clear-button"
                @click="clearSearch"
              >
                <span
                  aria-hidden="true"
                  class="c-icon c-icon--xxs c-main-nav__close-icon"
                >
                  <svg>
                    <use xlink:href="#icon-close"></use>
                  </svg>
                </span>
              </button>
              <div class="container-search-button">
                <button
                  type="submit"
                  class="c-main-nav__search-button c-contact-filter__button"
                  @click="searchContacts"
                >
                  <span class="t-visually-hidden">S&#246;k</span>
                  <span
                    aria-hidden="true"
                    class="c-icon c-icon--xs c-main-nav__search-icon"
                  >
                    <svg>
                      <use xlink:href="#icon-search"></use>
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div class="c-filter__button-container">
            <button class="c-filter__button-cancel" @click="closeMobileFilter">
              {{ this.translate.cancel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VFilterDropdown from "./dropdown/VFilterDropdown.vue";
import vClickOutside from "v-click-outside";
import { ref } from "vue";

export default {
  name: "VFilter",
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    VFilterDropdown,
  },

  props: {
    filters: {
      type: Array,
    },
    translate: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      activeFilter: "",
      showFilters: false,
      isDesktop: false,
      searchValue: "",
      dropdownOpen: false,
      selectedFilters: {},
    };
  },

  methods: {
    toggleDropdown(id) {
      this.activeFilter = this.activeFilter === id ? "" : id;
    },
    handleSelection(facet, option) {
      // saving selectedFilters
      this.selectedFilters[facet.id] = option.value;

      if (facet.id === "districtPageId") {
        delete this.selectedFilters["realEstateId"];
      }

      this.emitFilterData();
    },
    emitFilterData() {
      // Convert selectedFilters into a query string
      const queryParams = Object.entries(this.selectedFilters)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&");

      // Add Search query params
      const fullQuery = `${queryParams}&searchString=${this.searchValue || ""}`;

      this.$emit("filters-changed", fullQuery);
      this.activeFilter = "";
      this.showFilters = false;
      document.body.style.overflow = "auto";
    },

    getSelectedLabel(facet) {
      //getting selected label
      const selectedValue = this.selectedFilters[facet.id];
      if (!selectedValue) return facet.label;

      for (const opt of facet.options) {
        if (opt.value === selectedValue) return opt.text;

        if (opt.options && opt.options.length) {
          const sub = opt.options.find((s) => s.value === selectedValue);
          if (sub) return sub.text;
        }
      }

      // Fallback parent label
      return facet.label;
    },

    applyFiltersMobile() {
      this.emitFilterData();
      this.showFilters = false;
    },
    searchContacts() {
      if (this.isDesktop) {
        this.emitFilterData();
      } else {
        this.emitFilterData();
        this.showFilters = false;
      }
    },
    clearSearch() {
      this.searchValue = "";

      this.searchContacts();
    },
    closeMobileFilter() {
      this.showFilters = !this.showFilters;
      document.body.style.overflow = "auto";
    },
    checkScreenSize() {
      this.isDesktop = window.innerWidth >= 768;
    },
    showMobileFilters() {
      this.showFilters = true;
      document.body.style.overflow = "hidden";
    },
    handleClickOutside() {
      this.activeFilter = "";
    },
  },

  mounted() {
    /**on mount we look active options in filter object or we set first option as default */
    this.filters.forEach((filter) => {
      let activeOption = null;

      activeOption = filter.options && filter.options.find((opt) => opt.active);

      // check for an active sub-option
      if (!activeOption) {
        filter.options.forEach((opt) => {
          const subActive =
            opt.options && opt.options.find((sub) => sub.active);
          if (subActive) {
            activeOption = subActive;
          }
        });
      }

      if (!activeOption && filter.options.length > 0) {
        activeOption = filter.options[0];
      }

      if (activeOption) {
        // Initialize selectedFilters
        this.$set(this.selectedFilters, filter.id, activeOption.value);
        this.handleSelection(filter, activeOption);
      }
    });
  },

  created() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
};
</script>
